import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { FaTimes } from "react-icons/fa";
import { postRequest, putRequest, getRequest } from "../../apiWrapper";

Modal.setAppElement("#root");

// 新規作成／編集用モーダル
const NotificationFormModal = ({ initial, onClose }) => {
  const [title, setTitle] = useState("");
  const [message, setMessage] = useState("");
  const [targetRoles, setTargetRoles] = useState([]);
  const isEdit = Boolean(initial);

  useEffect(() => {
    if (initial) {
      setTitle(initial.title);
      setMessage(initial.message);
      setTargetRoles(initial.target_roles);
    }
  }, [initial]);

  const handleToggleRole = (role) => {
    setTargetRoles((prev) =>
      prev.includes(role) ? prev.filter((r) => r !== role) : [...prev, role]
    );
  };

  const handleSubmit = async () => {
    const payload = { title, message, target_roles: targetRoles };
    try {
      if (isEdit) {
        await putRequest(`notifications/${initial.id}`, payload);
      } else {
        await postRequest("notifications", payload);
      }
      onClose();
    } catch (err) {
      console.error("モーダル保存エラー:", err);
    }
  };

  return (
    <Modal
      isOpen
      onRequestClose={onClose}
      className="max-w-lg mx-auto mt-20 bg-white rounded-2xl shadow-lg p-6 relative"
      overlayClassName="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-start"
    >
      {/* 閉じるボタン */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 text-gray-500 hover:text-gray-700"
      >
        <FaTimes size={18} />
      </button>

      <h3 className="text-xl font-semibold mb-4">
        {isEdit ? "お知らせを編集" : "新しいお知らせを作成"}
      </h3>

      <div className="space-y-4">
        <div>
          <label className="block text-sm font-medium mb-1">タイトル</label>
          <input
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full border border-gray-300 rounded-lg p-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">本文</label>
          <textarea
            value={message}
            onChange={(e) => setMessage(e.target.value)}
            rows={4}
            className="w-full border border-gray-300 rounded-lg p-2 focus:ring-blue-500 focus:border-blue-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">対象ロール</label>
          <div className="flex gap-4">
            {['teacher','admin','student','parent'].map((role) => (
              <button
                key={role}
                type="button"
                onClick={() => handleToggleRole(role)}
                className={`px-3 py-1 rounded-full border transition ${
                  targetRoles.includes(role)
                    ? 'bg-blue-500 text-white border-blue-500'
                    : 'bg-white text-gray-700 border-gray-300 hover:bg-gray-100'
                }`}
              >
                {role}
              </button>
            ))}
          </div>
        </div>
        <div className="flex justify-end gap-3 mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-lg hover:bg-gray-300"
          >
            キャンセル
          </button>
          <button
            onClick={handleSubmit}
            className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600"
          >
            保存
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default NotificationFormModal